export const siteConfig = {
  name: "青青草视频",
  title: "青青草视频 | 妖精视频桃花视频影视大全与热门视频合集 | 苹果视频榴莲视频高清免费看",
  description: "青青草视频📢探索妖精视频、桃花视频、苹果视频、🔍榴莲视频等特色平台，提供影视大全、热门视频合集资源，满足用户对特定主题视频内容的需求。",
  keywords: "青青草视频,妖精视频,桃花视频,苹果视频,榴莲视频,影视大全,视频合集,热门视频,91视频网站,豆花视频,菠萝视频,红杏视频",
  url: "https://www.qingqingcao.com",
  logo: "青青草视频",
  slogan: "汇聚精彩视频，发现更多可能",
  foundingYear: "2020",
  email: "contact@qingqingcao.com",
  phone: "400-888-6666",
  address: "广东省广州市天河区体育西路108号",
};

export const videoPlatforms = [
  { name: "妖精视频", slug: "yaojing", description: "精选优质影视资源，高清流畅播放体验", icon: "ri-movie-2-line", gradient: "from-rose-500 to-pink-500" },
  { name: "桃花视频", slug: "taohua", description: "海量热门剧集，每日更新不断档", icon: "ri-flower-line", gradient: "from-amber-500 to-orange-500" },
  { name: "苹果视频", slug: "pingguo", description: "高清免费大片，极致观影享受", icon: "ri-smartphone-line", gradient: "from-emerald-500 to-teal-500" },
  { name: "榴莲视频", slug: "liulian", description: "特色主题内容，满足多样化需求", icon: "ri-plant-line", gradient: "from-yellow-500 to-lime-500" },
  { name: "豆花视频", slug: "douhua", description: "清新简洁界面，轻松找到好视频", icon: "ri-cup-line", gradient: "from-cyan-500 to-sky-500" },
  { name: "菠萝视频", slug: "boluo", description: "丰富内容库，总有你喜欢的", icon: "ri-fridge-line", gradient: "from-orange-500 to-yellow-500" },
  { name: "红杏视频", slug: "hongxing", description: "独特视角视频，发现不一样的世界", icon: "ri-heart-pulse-line", gradient: "from-red-500 to-rose-500" },
  { name: "91视频网站", slug: "91shipin", description: "经典视频合集，回味精彩时刻", icon: "ri-play-list-2-line", gradient: "from-violet-500 to-purple-500" },
];

export const categories = [
  { name: "影视大全", slug: "yingshidaquan", icon: "ri-film-line", count: 1280 },
  { name: "热门剧集", slug: "remenjuji", icon: "ri-tv-2-line", count: 856 },
  { name: "综艺娱乐", slug: "zongyiyule", icon: "ri-emotion-laugh-line", count: 642 },
  { name: "动漫动画", slug: "dongman", icon: "ri-ghost-line", count: 530 },
  { name: "纪录片", slug: "jilupian", icon: "ri-earth-line", count: 315 },
  { name: "短视频", slug: "duanshipin", icon: "ri-vidicon-line", count: 2100 },
  { name: "体育赛事", slug: "tiyusaishi", icon: "ri-basketball-line", count: 478 },
  { name: "游戏直播", slug: "youxizhibo", icon: "ri-gamepad-line", count: 920 },
  { name: "教育学习", slug: "jiaoyuxuexi", icon: "ri-book-open-line", count: 356 },
  { name: "音乐MV", slug: "yinle", icon: "ri-music-line", count: 1890 },
];